module.exports = __webpack_public_path__ + "static/media/appbackground.8d14dc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appbackground.jpg
// module id = 172
// module chunks = 7